import React, { useState, useEffect, useContext } from "react";
import { BlackAndWhite } from "../../themes/Colors";
import useWindowDimensions from "../../components/get-diemensions/UseWindowDiemensions";
import {
  BaseButtons,
  SectionTitle,
  TextAreaInput,
  TextInputField,
  TextInputFieldSearch,
} from "../../components/atoms";
import { AdminContext } from "../../context/admin-context";
import { useNavigate } from "react-router-dom";
import AdminCustomerTab from "./components/AdminCustomerTab";
import QuestionButton from "../customer-portal/components/medical-history/components/button/QuestionButton";
import Users from "./components/Users";
import { LoadingPopUp, MenuDropDown } from "../../components";
import DropDownButton from "../../components/drop-down-button/DropDownButton";
import Facilities from "./components/Facilities";
import Menus from "./components/Menus";
import { CSVLink } from "react-csv";
import DashBoard from "./components/DashBoard";
import MultiSelectorDate from "./components/multi-selector-date/MultiSelectorDate";
import MainScreenHolder from "./components/product-uploader/MainScreenHolder";
import ExcelExport from "./components/ExcelExport";
import { ProfileMenu } from "../canna-pos/components";
import WebsiteDisplayEdit from "./components/website-display-edit/WebsiteDisplayEdit";
import Inventory from "./components/inventory/Inventory";
import { HeadersPatients } from "../canna-pos/components/patient-display/components";
import PatientProfilePopUp from "./components/PatientProfilePopUp";
import Reporting from "./components/reporting/Reporting";
import {
  PractionerHeader,
  PractionerTab,
} from "./components/practioners-components";

// import { useNavigate } from "react-router-dom";

const AdminEditor = () => {
  const { width, height } = useWindowDimensions();
  const [shrink, setShrink] = useState(false);

  const [onMenu, setOnMenu] = useState(false);
  const [patientStats, setPatientsStats] = useState(null);
  const [patientStatsAvalible, setPatientsStatsAvalible] = useState(false);
  // const [prescriptionStats, setPrescriptionStats] = useState(null);

  const [patientCsvDownloadPopUp, setPatientCsvDownloadPopUp] = useState(false);
  const [day, setDay] = useState("");
  const [month, setMonth] = useState("");
  const [dayDate, setDayDate] = useState("");

  const [dayRegList, setDayRegList] = useState(null);

  const [tab, setTab] = useState("dashboard");
  const [subSelection, setSubSelection] = useState("none");
  const [userDisplay, setUserdisplay] = useState(false);
  const [csvExport, setCsvExport] = useState(null);

  const [websiteData, setWebsiteData] = useState(null);
  // const [urlPath, setUrlPath] = useState("");
  const admin = useContext(AdminContext);
  const navigate = useNavigate();

  const [storeStats, setStoreStats] = useState(null);
  const [productStats, setProductStats] = useState(null);
  const [saleStats, setSaleStats] = useState(null);
  const [staffStats, setStaffStats] = useState(null);

  //website welcome update fields
  const [welcomParaGraph1, setWelcomParagraph1] = useState("");
  const [welcomParaGraph2, setWelcomParagraph2] = useState("");
  const [welcomParaGraph3, setWelcomParagraph3] = useState("");

  const [merryFacesInfo, setMerryFacesInfo] = useState("");

  const [loading, setLoading] = useState(false);
  // const [error, setError] = useState(null);

  const [refresh, setRefresh] = useState(false);

  const [search, setSearch] = useState("");
  const [customers, setCustomers] = useState(null);
  const [patientProfilePop, setPatientProfilePop] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState(null);

  const OnUserSearch = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        "https://budloungedatabase.onrender.com/user/searchForUserPos",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            searchParameter: search,
            userId: admin.adminUserData.userId,
          }),
        }
      );

      const responseData = await response.json();

      setLoading(false);
      if (responseData.success) {
        setCustomers(responseData.data);
      }
    } catch (err) {
      setLoading(false);
    }
  };

  const downloadListfFetch = async () => {
    setLoading(true);

    try {
      const response = await fetch(
        "https://budloungedatabase.onrender.com/user/getPatintientList",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            date: day + " " + month + " " + dayDate + " " + "2024",
          }),
        }
      );

      const responseData = await response.json();
      if (!responseData.message) {
        setLoading(false);
        setDayRegList(responseData);
      }
    } catch (err) {
      setLoading(false);
    }
  };

  const GetStoreStats = async () => {
    try {
      const response = await fetch(
        "https://budloungedatabase.onrender.com/admin/getStoreStatus",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: admin.adminUserData.userId,
          }),
        }
      );

      const responseData = await response.json();
      if (!responseData.error && !responseData.accessDenied) {
        setLoading(false);
        setStoreStats(responseData);
      }
    } catch (err) {
      setLoading(false);
    }
  };

  const GetProductStats = async () => {
    try {
      const response = await fetch(
        "https://budloungedatabase.onrender.com/admin/getproductsStats",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: admin.adminUserData.userId,
          }),
        }
      );

      const responseData = await response.json();
      if (!responseData.error && !responseData.accessDenied) {
        setLoading(false);
        setProductStats(responseData.categoryFilteredList);
      }
    } catch (err) {
      setLoading(false);
    }
  };
  const GetStaffStats = async () => {
    try {
      const response = await fetch(
        "https://budloungedatabase.onrender.com/admin/getStaffStats",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: admin.adminUserData.userId,
          }),
        }
      );

      const responseData = await response.json();
      if (!responseData.error && !responseData.accessDenied) {
        setLoading(false);
        setStaffStats(responseData);
      }
    } catch (err) {
      setLoading(false);
    }
  };

  const GoToSupport = () => {
    navigate("/supportAccess");
  };

  useEffect(() => {
    if (
      !admin.isloggedIn ||
      admin.adminUserData.type === "Customer" ||
      admin.adminUserData.type === "Doctor" ||
      admin.adminUserData.type === "Manager" ||
      admin.adminUserData.type === "Support" ||
      admin.adminUserData.type === "Investor"
    ) {
      navigate("/adminPortal");
    }
  }, []);

  useEffect(() => {
    setLoading(true);

    fetch("https://budloungedatabase.onrender.com/admin/getPatientStats")
      .then((response) => {
        return response.json();
      })
      .then((resData) => {
        setPatientsStats(resData);
        setPatientsStatsAvalible(true);
      });
    // fetch(
    //   "https://budloungedatabase.onrender.com/prescription/prescriptionStats"
    // )
    //   .then((response) => {
    //     return response.json();
    //   })
    //   .then((resData) => {
    //     setPrescriptionStats(resData);
    //     setLoading(false);
    //   });
    GetStaffStats();
    GetStoreStats();
    GetProductStats();
  }, [refresh]);
  // useEffect(() => {
  //   fetch(
  //     "https://budloungedatabase.onrender.com/website/adminFetch/65784e47833b40e2a6f54c47"
  //   )
  //     .then((response) => {
  //       return response.json();
  //     })
  //     .then((resData) => {
  //       setWebsiteData(resData);
  //     });
  // }, [loading]);
  useEffect(() => {
    if (day !== "" && month !== "" && dayDate !== "") {
      //here will be the download trigger
      downloadListfFetch();
    }
  }, [day, month, dayDate]);

  // let paresedFile = JSON.parse(csvExport.users);

  return (
    <div
      style={{
        height: height,
        width: width,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        overflowX: "hidden",
        backgroundColor: BlackAndWhite.red,
        position: "relative",
        msOverflowX: "hidden",
        msOverflowY: "hidden",
        overflow: "hidden",
      }}
    >
      {/* // top margin display header */}
      <div
        style={{
          fontSize: 30,
          fontWeight: "700",
          color: BlackAndWhite.secondary,
          position: "fixed",
          width: width,
          backgroundColor: BlackAndWhite.primary,
          top: 0,
          height: 60,
          display: "flex",
          alignItems: "center",
          zIndex: 1000000002,
          // WebkitBoxShadow: "0px 0px 10px 1px #00000033",
        }}
      >
        <div
          style={{
            flex: 1,
            position: "relative",
            display: "flex",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: "80%",
              backgroundColor: BlackAndWhite.primary,
              height: 50,
              marginLeft: 60,
              alignItems: "center",
              transition: "all 0.3s",
              WebkitBoxShadow: "0px 0px 10px 1px #00000033",
              zIndex: 100000002,
              // marginLeft: shrink ? 0 : 0,
              // borderRightStyle: "solid",
              // borderWidth: 4,
              // borderColor: BlackAndWhite.red,
            }}
          >
            <div style={{ height: shrink ? 85 : 80, transition: "all 0.3s" }} />
            {tab === "dashboard" ? null : shrink ? (
              <div
                onClick={() => {
                  setTab("dashboard");
                  setUserdisplay(false);
                  setSubSelection("none");
                }}
                style={{
                  height: 40,
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img
                  alt="icon"
                  src={require("../../images/material-icons/backLeftWhite.png")}
                  style={{
                    height: 25,
                    // borderStyle: "solid",
                    borderWidth: 1,
                    borderRadius: 100,
                    padding: 5,
                    marginBottom: 10,
                  }}
                />
              </div>
            ) : (
              <div
                onClick={() => {
                  setTab("dashboard");
                  setUserdisplay(false);
                  setSubSelection("none");
                }}
                style={{
                  height: 40,
                  width: 80,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img
                  alt="icon"
                  src={require("../../images/material-icons/backLeftWhite.png")}
                  style={{
                    height: 25,
                    // borderStyle: "solid",
                    borderWidth: 1,
                    borderRadius: 100,
                    padding: 5,
                    // marginBottom: 10,
                  }}
                />
              </div>
            )}

            {tab === "dashboard" ? (
              <>
                <QuestionButton
                  borderOn={tab === "dashboard" ? true : false}
                  title={shrink ? null : "DASHBOARD"}
                  height={60}
                  onClick={() => setTab("dashboard")}
                  backgroundColor={
                    tab === "dashboard"
                      ? BlackAndWhite.secondary
                      : BlackAndWhite.primary
                  }
                  backgroundColorAlt={BlackAndWhite.secondary}
                  color={
                    tab === "dashboard"
                      ? BlackAndWhite.primary
                      : BlackAndWhite.secondary
                  }
                  colorAlt={BlackAndWhite.primary}
                  width={150}
                  icon={
                    tab === "dashboard"
                      ? require("../../images/material-icons/dashboardBlack.png")
                      : require("../../images/material-icons/dashboardWhite.png")
                  }
                  selected={tab === "dashboard" ? true : false}
                  questionAmount={true}
                  // borderRadius={shrink ? "100%" : 8}
                />
                {/* <div style={{ height: 5 }} /> */}
              </>
            ) : null}

            {tab === "products" || tab === "dashboard" ? (
              <>
                <QuestionButton
                  // inProgress={true}
                  // borderRadius={shrink ? "100%" : tab === "products" ? 8 : 8}
                  borderOn={shrink ? true : tab === "products" ? true : false}
                  title={shrink ? null : "PRODUCTS"}
                  height={shrink ? 60 : tab === "products" ? 60 : 60}
                  onClick={() => {
                    setTab("products");
                    setSubSelection("productList");
                  }}
                  backgroundColor={
                    tab === "products"
                      ? BlackAndWhite.secondary
                      : BlackAndWhite.primary
                  }
                  backgroundColorAlt={BlackAndWhite.secondary}
                  color={
                    tab === "products"
                      ? BlackAndWhite.primary
                      : BlackAndWhite.secondary
                  }
                  colorAlt={BlackAndWhite.primary}
                  width={150}
                  icon={
                    tab === "products"
                      ? require("../../images/material-icons/productBlack.png")
                      : require("../../images/material-icons/productWhite.png")
                  }
                  icon2={require("../../images/material-icons/productBlack.png")}
                  selected={tab === "products" ? true : false}
                  questionAmount={true}
                />

                {tab === "products" ? (
                  <>
                    <BaseButtons
                      // selected={subSelection === "productList" ? true : false}
                      onClick={() => setSubSelection("productList")}
                      marginTopFalse={true}
                      label={"ITEMS"}
                      mini={true}
                      invert={subSelection === "productList" ? false : true}
                      height={40}
                      width={150}
                      fontSize={shrink ? 10 : null}
                      // borderRadius={8}
                      menuButton={true}
                      // marginTop={5}
                      fontColor={
                        subSelection === "productList"
                          ? BlackAndWhite.secondary
                          : BlackAndWhite.primary
                      }
                      fontWeight={"bold"}
                      backgroundColor={
                        subSelection === "productList"
                          ? BlackAndWhite.red
                          : BlackAndWhite.secondary
                      }
                    />
                  </>
                ) : null}
                {tab === "products" ? (
                  <BaseButtons
                    // selected={subSelection === "productList" ? true : false}
                    onClick={() => setSubSelection("encyclopedia")}
                    marginTopFalse={true}
                    label={"PRODUCT INFO"}
                    mini={true}
                    invert={subSelection === "encyclopedia" ? false : true}
                    height={40}
                    width={150}
                    marginTop={5}
                    fontSize={shrink ? 10 : null}
                    // borderRadius={8}
                    menuButton={true}
                    fontColor={
                      subSelection === "encyclopedia"
                        ? BlackAndWhite.secondary
                        : BlackAndWhite.primary
                    }
                    fontWeight={"bold"}
                    backgroundColor={
                      subSelection === "encyclopedia"
                        ? BlackAndWhite.red
                        : BlackAndWhite.secondary
                    }
                  />
                ) : null}
                {tab === "products" ? (
                  <BaseButtons
                    // selected={subSelection === "productList" ? true : false}
                    onClick={() => setSubSelection("promotions")}
                    marginTopFalse={true}
                    label={"PROMOTIONS"}
                    mini={true}
                    invert={subSelection === "promotions" ? false : true}
                    height={40}
                    width={150}
                    marginTop={5}
                    fontSize={shrink ? 10 : null}
                    // borderRadius={8}
                    menuButton={true}
                    fontColor={
                      subSelection === "promotions"
                        ? BlackAndWhite.secondary
                        : BlackAndWhite.primary
                    }
                    fontWeight={"bold"}
                    backgroundColor={
                      subSelection === "promotions"
                        ? BlackAndWhite.red
                        : BlackAndWhite.secondary
                    }
                  />
                ) : null}
                {/* {tab === "products" ? (
                  <BaseButtons
                    // selected={subSelection === "productList" ? true : false}
                    onClick={() => setSubSelection("attribute")}
                    marginTopFalse={false}
                    label={"ATTRIBUTES"}
                    mini={true}
                    invert={subSelection === "attribute" ? false : true}
                    height={40}
                    width={"100%"}
                    size={"95%"}
                    marginTop={5}
                    fontSize={shrink ? 10 : null}
                    borderRadius={8}
                    menuButton={true}
                    disable={true}
                  />
                ) : null}
                {tab === "products" ? (
                  <BaseButtons
                    // selected={subSelection === "productList" ? true : false}
                    onClick={() => setSubSelection("labels")}
                    marginTopFalse={false}
                    label={"LABELS"}
                    mini={true}
                    invert={subSelection === "labels" ? false : true}
                    height={40}
                    width={"100%"}
                    size={"95%"}
                    marginTop={5}
                    fontSize={shrink ? 10 : null}
                    borderRadius={8}
                    menuButton={true}
                    disable={true}
                  />
                ) : null}
                {tab === "products" ? (
                  <BaseButtons
                    // selected={subSelection === "productList" ? true : false}
                    onClick={() => setSubSelection("offers")}
                    marginTopFalse={false}
                    label={"OFFERS"}
                    mini={true}
                    invert={subSelection === "offers" ? false : true}
                    height={40}
                    width={"100%"}
                    size={"95%"}
                    marginTop={5}
                    fontSize={shrink ? 10 : null}
                    borderRadius={8}
                    menuButton={true}
                    disable={true}
                  />
                ) : null} */}
              </>
            ) : null}
            {tab === "inventory" || tab === "dashboard" ? (
              <>
                <QuestionButton
                  // notAvailable={true}
                  // borderRadius={shrink ? "100%" : 8}
                  borderOn={tab === "inventory" ? true : false}
                  title={shrink ? null : "INVENTORY"}
                  height={60}
                  onClick={
                    tab === "inventory"
                      ? null
                      : () => {
                          setTab("inventory");
                          setSubSelection("dashboard");
                        }
                  }
                  backgroundColor={
                    tab === "inventory"
                      ? BlackAndWhite.secondary
                      : BlackAndWhite.primary
                  }
                  backgroundColorAlt={BlackAndWhite.secondary}
                  color={
                    tab === "inventory"
                      ? BlackAndWhite.primary
                      : BlackAndWhite.secondary
                  }
                  colorAlt={BlackAndWhite.primary}
                  width={150}
                  icon={
                    tab === "inventory"
                      ? require("../../images/material-icons/inventoryBlack.png")
                      : require("../../images/material-icons/inventoryWhite.png")
                  }
                  icon2={require("../../images/material-icons/inventoryBlack.png")}
                  selected={tab === "inventory" ? true : false}
                  questionAmount={true}
                />

                {tab === "inventory" ? (
                  <BaseButtons
                    // selected={subSelection === "productList" ? true : false}
                    onClick={() => setSubSelection("dashboard")}
                    marginTopFalse={true}
                    label={"DASHBOARD"}
                    mini={true}
                    invert={subSelection === "dashboard" ? false : true}
                    height={50}
                    width={160}
                    size={160}
                    fontSize={shrink ? 10 : null}
                    // borderRadius={8}
                    menuButton={true}
                    fontColor={
                      subSelection === "dashboard"
                        ? BlackAndWhite.secondary
                        : BlackAndWhite.primary
                    }
                    fontWeight={"bold"}
                    borderWidth={0}
                    backgroundColor={
                      subSelection === "dashboard"
                        ? BlackAndWhite.red
                        : BlackAndWhite.secondary
                    }
                  />
                ) : null}

                {tab === "inventory" ? (
                  <BaseButtons
                    // selected={subSelection === "productList" ? true : false}
                    onClick={() => setSubSelection("myInventory")}
                    marginTopFalse={true}
                    label={"MY INVENTORY"}
                    mini={true}
                    invert={subSelection === "myInventory" ? false : true}
                    height={50}
                    width={160}
                    size={160}
                    fontSize={shrink ? 10 : null}
                    // borderRadius={8}
                    menuButton={true}
                    // marginTop={5}
                    borderWidth={0}
                    fontColor={
                      subSelection === "myInventory"
                        ? BlackAndWhite.secondary
                        : BlackAndWhite.primary
                    }
                    fontWeight={"bold"}
                    backgroundColor={
                      subSelection === "myInventory"
                        ? BlackAndWhite.red
                        : BlackAndWhite.secondary
                    }
                  />
                ) : null}
                {/* {tab === "inventory" ? (
              <BaseButtons
                // selected={subSelection === "productList" ? true : false}
                onClick={() => setSubSelection("countStockTake")}
                // marginTopFalse={true}
                label={"COUNT.STOCK TAKE"}
                mini={true}
                invert={subSelection === "countStockTake" ? false : true}
                height={40}
                width={"100%"}
                size={"95%"}
                fontSize={shrink ? 10 : null}
                borderRadius={8}
                marginTop={5}
                menuButton={true}
              />
            ) : null} */}
                {tab === "inventory" ? (
                  <BaseButtons
                    // selected={subSelection === "productList" ? true : false}
                    onClick={() => setSubSelection("transfers")}
                    marginTopFalse={true}
                    label={"TRANSFER DOCS"}
                    mini={true}
                    invert={subSelection === "transfers" ? false : true}
                    height={50}
                    width={160}
                    size={160}
                    borderWidth={0}
                    fontSize={shrink ? 10 : null}
                    // borderRadius={8}
                    marginTop={5}
                    menuButton={true}
                    fontColor={
                      subSelection === "transfers"
                        ? BlackAndWhite.secondary
                        : BlackAndWhite.primary
                    }
                    fontWeight={"bold"}
                    backgroundColor={
                      subSelection === "transfers"
                        ? BlackAndWhite.red
                        : BlackAndWhite.secondary
                    }
                  />
                ) : null}
              </>
            ) : null}
            {tab === "patients" || tab === "dashboard" ? (
              <>
                {" "}
                <QuestionButton
                  // borderRadius={shrink ? "100%" : 8}
                  borderOn={tab === "patients" ? true : false}
                  title={shrink ? null : "PATIENTS"}
                  height={60}
                  onClick={
                    tab === "patients"
                      ? () => setTab("dashboard")
                      : () => setTab("patients")
                  }
                  backgroundColor={
                    tab === "patients"
                      ? BlackAndWhite.secondary
                      : BlackAndWhite.primary
                  }
                  backgroundColorAlt={BlackAndWhite.secondary}
                  color={
                    tab === "patients"
                      ? BlackAndWhite.primary
                      : BlackAndWhite.secondary
                  }
                  colorAlt={BlackAndWhite.primary}
                  width={150}
                  icon={
                    tab === "patients"
                      ? require("../../images/material-icons/profileBlack.png")
                      : require("../../images/material-icons/profileWhite.png")
                  }
                  icon2={require("../../images/material-icons/profileBlack.png")}
                  selected={tab === "patients" ? true : false}
                  questionAmount={true}
                />
                {/* <div style={{ height: 5 }} /> */}
                {/* {tab === "patients" ? (
              <BaseButtons
                // selected={subSelection === "productList" ? true : false}
                onClick={() => setSubSelection("patients")}
                marginTopFalse={false}
                label={"PATIENTS"}
                mini={true}
                invert={subSelection === "patients" ? false : true}
                height={40}
                width={"100%"}
                size={"95%"}
                fontSize={shrink ? 10 : null}
                borderRadius={8}
                marginTop={5}
                menuButton={true}
              />
            ) : null}
            {tab === "patients" ? (
              <BaseButtons
                // selected={subSelection === "productList" ? true : false}
                onClick={() => setSubSelection("prescriptions")}
                marginTopFalse={false}
                label={"PRESCRIPTIONS"}
                mini={true}
                invert={subSelection === "prescriptions" ? false : true}
                height={40}
                width={"100%"}
                size={"95%"}
                fontSize={shrink ? 10 : null}
                borderRadius={8}
                marginTop={5}
                menuButton={true}
              />
            ) : null} */}
              </>
            ) : null}

            {tab === "reporting" || tab === "dashboard" ? (
              <>
                <QuestionButton
                  // notAvailable={true}
                  // borderRadius={shrink ? "100%" : 8}
                  borderOn={tab === "reporting" ? true : false}
                  title={shrink ? null : "REPORTING"}
                  height={60}
                  onClick={
                    tab === "reporting"
                      ? () => setTab("dashboard")
                      : () => {
                          setTab("reporting");
                          setSubSelection("dashboard");
                        }
                  }
                  backgroundColor={
                    tab === "reporting"
                      ? BlackAndWhite.secondary
                      : BlackAndWhite.primary
                  }
                  backgroundColorAlt={BlackAndWhite.secondary}
                  color={
                    tab === "reporting"
                      ? BlackAndWhite.primary
                      : BlackAndWhite.secondary
                  }
                  colorAlt={BlackAndWhite.primary}
                  width={150}
                  size={150}
                  icon={
                    tab === "reporting"
                      ? require("../../images/material-icons/reportBlack.png")
                      : require("../../images/material-icons/reportWhite.png")
                  }
                  icon2={require("../../images/material-icons/reportBlack.png")}
                  selected={tab === "reporting" ? true : false}
                  questionAmount={true}
                />

                {tab === "reporting" ? (
                  <BaseButtons
                    // selected={subSelection === "productList" ? true : false}
                    onClick={() => setSubSelection("dashboard")}
                    marginTopFalse={true}
                    label={"DASHBOARD"}
                    mini={true}
                    invert={subSelection === "dashboard" ? false : true}
                    height={50}
                    width={160}
                    size={160}
                    fontSize={shrink ? 10 : null}
                    // borderRadius={8}
                    menuButton={true}
                    backgroundColor={
                      subSelection === "dashboard"
                        ? BlackAndWhite.red
                        : BlackAndWhite.secondary
                    }
                    borderWidth={0}
                    fontColor={
                      subSelection === "dashboard"
                        ? BlackAndWhite.secondary
                        : BlackAndWhite.primary
                    }
                    fontWeight={"bold"}
                  />
                ) : null}

                {tab === "reporting" ? (
                  <BaseButtons
                    // selected={subSelection === "productList" ? true : false}
                    onClick={() => setSubSelection("sales")}
                    marginTopFalse={true}
                    label={"SALES"}
                    mini={true}
                    invert={subSelection === "sales" ? true : false}
                    height={50}
                    width={150}
                    size={150}
                    borderWidth={0}
                    fontSize={shrink ? 10 : null}
                    menuButton={true}
                    backgroundColor={
                      subSelection === "sales"
                        ? BlackAndWhite.red
                        : BlackAndWhite.secondary
                    }
                    fontColor={
                      subSelection === "sales"
                        ? BlackAndWhite.secondary
                        : BlackAndWhite.primary
                    }
                    fontWeight={"bold"}
                  />
                ) : null}
                {tab === "reporting" ? (
                  <BaseButtons
                    // selected={subSelection === "productList" ? true : false}
                    onClick={() => setSubSelection("inventoryReport")}
                    marginTopFalse={true}
                    label={"INVENTORY"}
                    mini={true}
                    fontWeight={"bold"}
                    invert={subSelection === "inventoryReport" ? true : false}
                    height={50}
                    width={160}
                    size={160}
                    fontSize={shrink ? 10 : null}
                    backgroundColor={
                      subSelection === "inventoryReport"
                        ? BlackAndWhite.red
                        : BlackAndWhite.secondary
                    }
                    fontColor={
                      subSelection === "inventoryReport"
                        ? BlackAndWhite.secondary
                        : BlackAndWhite.primary
                    }
                    // borderRadius={8}
                    // marginTop={5}
                    menuButton={true}
                    // disable={true}
                  />
                ) : null}
                {tab === "reporting" ? (
                  <BaseButtons
                    // selected={subSelection === "productList" ? true : false}
                    onClick={() => setSubSelection("discounts")}
                    marginTopFalse={true}
                    label={"PROMOTIONS"}
                    mini={true}
                    invert={subSelection === "discounts" ? true : false}
                    height={50}
                    width={150}
                    size={150}
                    borderWidth={0}
                    fontSize={shrink ? 10 : null}
                    menuButton={true}
                    backgroundColor={
                      subSelection === "discounts"
                        ? BlackAndWhite.red
                        : BlackAndWhite.secondary
                    }
                    fontColor={
                      subSelection === "discounts"
                        ? BlackAndWhite.secondary
                        : BlackAndWhite.primary
                    }
                    fontWeight={"bold"}
                    // disable={true}
                  />
                ) : null}

                {tab === "reporting" ? (
                  <BaseButtons
                    // selected={subSelection === "productList" ? true : false}
                    onClick={() => setSubSelection("register")}
                    marginTopFalse={true}
                    label={"REGISTER"}
                    mini={true}
                    invert={subSelection === "register" ? true : false}
                    // borderRadius={8}
                    // marginTop={5}
                    menuButton={true}
                    height={50}
                    width={150}
                    size={150}
                    borderWidth={0}
                    fontSize={shrink ? 10 : null}
                    backgroundColor={
                      subSelection === "register"
                        ? BlackAndWhite.red
                        : BlackAndWhite.secondary
                    }
                    fontColor={
                      subSelection === "register"
                        ? BlackAndWhite.secondary
                        : BlackAndWhite.primary
                    }
                    fontWeight={"bold"}
                    // disable={true}
                  />
                ) : null}
                {tab === "reporting" ? (
                  <BaseButtons
                    // selected={subSelection === "productList" ? true : false}
                    onClick={() => setSubSelection("timesheets")}
                    marginTopFalse={true}
                    label={"TIME SHEETS"}
                    mini={true}
                    invert={subSelection === "timesheets" ? true : false}
                    // borderRadius={8}
                    // marginTop={5}
                    menuButton={true}
                    height={50}
                    width={160}
                    size={160}
                    borderWidth={0}
                    fontSize={shrink ? 10 : null}
                    backgroundColor={
                      subSelection === "timesheets"
                        ? BlackAndWhite.red
                        : BlackAndWhite.secondary
                    }
                    fontColor={
                      subSelection === "timesheets"
                        ? BlackAndWhite.secondary
                        : BlackAndWhite.primary
                    }
                    fontWeight={"bold"}
                    // disable={true}
                  />
                ) : null}
                {tab === "reporting" ? (
                  <BaseButtons
                    // selected={subSelection === "productList" ? true : false}
                    onClick={() => setSubSelection("tips")}
                    marginTopFalse={true}
                    label={"TIPS BREAKDOWN"}
                    mini={true}
                    invert={subSelection === "tips" ? false : true}
                    // borderRadius={8}
                    // marginTop={5}
                    menuButton={true}
                    height={50}
                    width={160}
                    size={160}
                    borderWidth={0}
                    fontSize={shrink ? 10 : null}
                    backgroundColor={
                      subSelection === "tips"
                        ? BlackAndWhite.red
                        : BlackAndWhite.secondary
                    }
                    fontColor={
                      subSelection === "tips"
                        ? BlackAndWhite.secondary
                        : BlackAndWhite.primary
                    }
                    fontWeight={"bold"}
                    // disable={true}
                  />
                ) : null}
                {/* {tab === "reporting" ? (
                  <BaseButtons
                    // selected={subSelection === "productList" ? true : false}
                    onClick={() => setSubSelection("payments")}
                    // marginTopFalse={true}
                    label={"PAYMENTS"}
                    mini={true}
                    invert={subSelection === "payments" ? false : true}
                    height={40}
                    width={"100%"}
                    size={"95%"}
                    fontSize={shrink ? 10 : null}
                    borderRadius={8}
                    marginTop={5}
                    menuButton={true}
                    disable={true}
                  />
                ) : null}
                {tab === "reporting" ? (
                  <BaseButtons
                    // selected={subSelection === "productList" ? true : false}
                    onClick={() => setSubSelection("customerReporting")}
                    // marginTopFalse={true}
                    label={"CUSTOMERS"}
                    mini={true}
                    invert={subSelection === "customerReporting" ? false : true}
                    height={40}
                    width={"100%"}
                    size={"95%"}
                    fontSize={shrink ? 10 : null}
                    borderRadius={8}
                    marginTop={5}
                    menuButton={true}
                    disable={true}
                  />
                ) : null}
                {tab === "reporting" ? (
                  <BaseButtons
                    // selected={subSelection === "productList" ? true : false}
                    onClick={() => setSubSelection("faciltiesReporting")}
                    // marginTopFalse={true}
                    label={"FACILITIES"}
                    mini={true}
                    invert={
                      subSelection === "faciltiesReporting" ? false : true
                    }
                    height={40}
                    width={"100%"}
                    size={"95%"}
                    fontSize={shrink ? 10 : null}
                    borderRadius={8}
                    marginTop={5}
                    menuButton={true}
                    disable={true}
                  />
                ) : null} */}
              </>
            ) : null}
            {tab === "setupManage" || tab === "dashboard" ? (
              <>
                <QuestionButton
                  // notAvailable={true}
                  // borderRadius={shrink ? "100%" : 8}
                  borderOn={tab === "setupManage" ? true : false}
                  title={shrink ? null : "SETUP AND MANAGE"}
                  height={60}
                  onClick={
                    tab === "setupManage"
                      ? () => setTab("dashboard")
                      : () => {
                          setTab("setupManage");
                          setSubSelection("All FACILITES");
                        }
                  }
                  backgroundColor={
                    tab === "setupManage"
                      ? BlackAndWhite.secondary
                      : BlackAndWhite.primary
                  }
                  backgroundColorAlt={BlackAndWhite.secondary}
                  color={
                    tab === "setupManage"
                      ? BlackAndWhite.primary
                      : BlackAndWhite.secondary
                  }
                  colorAlt={BlackAndWhite.primary}
                  width={180}
                  icon={
                    tab === "setupManage"
                      ? require("../../images/material-icons/setupAndMangeBlack.png")
                      : require("../../images/material-icons/setupAndMangeWhite.png")
                  }
                  icon2={require("../../images/material-icons/setupAndMangeBlack.png")}
                  selected={tab === "setupManage" ? true : false}
                  questionAmount={true}
                />

                {tab === "setupManage" ? (
                  <BaseButtons
                    // selected={subSelection === "productList" ? true : false}
                    onClick={() => setSubSelection("All FACILITES")}
                    marginTopFalse={true}
                    label={"FACILITIES"}
                    mini={true}
                    invert={subSelection === "All FACILITES" ? false : true}
                    height={50}
                    width={150}
                    size={150}
                    fontSize={shrink ? 10 : null}
                    // borderRadius={8}
                    menuButton={true}
                    backgroundColor={
                      subSelection === "All FACILITES"
                        ? BlackAndWhite.red
                        : BlackAndWhite.secondary
                    }
                    fontColor={
                      subSelection === "All FACILITES"
                        ? BlackAndWhite.secondary
                        : BlackAndWhite.primary
                    }
                    fontWeight={"bold"}
                    borderWidth={0}
                  />
                ) : null}
                {tab === "setupManage" ? (
                  <BaseButtons
                    // selected={subSelection === "productList" ? true : false}
                    onClick={() => setSubSelection("ALL USERS")}
                    // marginTopFalse={true}
                    label={"USERS"}
                    mini={true}
                    invert={subSelection === "ALL USERS" ? false : true}
                    height={50}
                    width={150}
                    size={150}
                    fontSize={shrink ? 10 : null}
                    // borderRadius={8}
                    // marginTop={5}
                    borderWidth={0}
                    marginTopFalse={true}
                    menuButton={true}
                    backgroundColor={
                      subSelection === "ALL USERS"
                        ? BlackAndWhite.red
                        : BlackAndWhite.secondary
                    }
                    fontColor={
                      subSelection === "ALL USERS"
                        ? BlackAndWhite.secondary
                        : BlackAndWhite.primary
                    }
                    fontWeight={"bold"}
                  />
                ) : null}
                {tab === "setupManage" ? (
                  <BaseButtons
                    // selected={subSelection === "productList" ? true : false}
                    onClick={() => setSubSelection("practioners")}
                    marginTopFalse={true}
                    label={"PRACTIONERS"}
                    mini={true}
                    invert={subSelection === "practioners" ? true : false}
                    height={50}
                    width={150}
                    size={150}
                    fontSize={shrink ? 10 : null}
                    // borderRadius={8}
                    marginTop={5}
                    menuButton={true}
                    borderWidth={0}
                    backgroundColor={
                      subSelection === "practioners"
                        ? BlackAndWhite.red
                        : BlackAndWhite.secondary
                    }
                    fontColor={
                      subSelection === "practioners"
                        ? BlackAndWhite.secondary
                        : BlackAndWhite.primary
                    }
                    fontWeight={"bold"}
                    // disable={true}
                  />
                ) : null}
                {tab === "setupManage" ? (
                  <BaseButtons
                    // selected={subSelection === "productList" ? true : false}
                    onClick={() => setSubSelection("suppliers")}
                    marginTopFalse={true}
                    label={"SUPPLIERS"}
                    mini={true}
                    invert={subSelection === "suppliers" ? true : false}
                    height={50}
                    width={150}
                    size={150}
                    fontSize={shrink ? 10 : null}
                    // borderRadius={8}
                    marginTop={5}
                    menuButton={true}
                    borderWidth={0}
                    backgroundColor={
                      subSelection === "suppliers"
                        ? BlackAndWhite.red
                        : BlackAndWhite.secondary
                    }
                    fontColor={
                      subSelection === "suppliers"
                        ? BlackAndWhite.secondary
                        : BlackAndWhite.primary
                    }
                    fontWeight={"bold"}
                  />
                ) : null}
              </>
            ) : null}

            {tab === "dashboard" ? (
              <>
                <QuestionButton
                  borderOn={tab === "support" ? true : false}
                  title={shrink ? null : "SUPPORT"}
                  height={60}
                  onClick={() => GoToSupport()}
                  backgroundColor={
                    tab === "support"
                      ? BlackAndWhite.secondary
                      : BlackAndWhite.primary
                  }
                  backgroundColorAlt={BlackAndWhite.secondary}
                  color={
                    tab === "support"
                      ? BlackAndWhite.primary
                      : BlackAndWhite.secondary
                  }
                  colorAlt={BlackAndWhite.primary}
                  width={150}
                  icon={
                    tab === "support"
                      ? require("../../images/material-icons/qrCodeBlack.png")
                      : require("../../images/material-icons/qrcodeWhite.png")
                  }
                  icon2={require("../../images/material-icons/qrCodeBlack.png")}
                  selected={tab === "support" ? true : false}
                  questionAmount={true}
                  // borderRadius={shrink ? "100%" : 8}
                />
                <div style={{ height: 5 }} />
              </>
            ) : null}

            <div style={{ height: 5 }} />
          </div>
        </div>

        <div
          style={{
            marginRight: 20,
            fontSize: 12,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontWeight: "bold",
          }}
        >
          <div style={{ marginRight: 4 }}>
            {admin.adminUserData ? admin.adminUserData.firstName : "loading"}
          </div>
          <div style={{ marginRight: 12 }}>
            {admin.adminUserData ? admin.adminUserData.lastName : "loading"}
          </div>
          {/* //menu button */}
          <div
            onClick={() => setOnMenu(onMenu ? false : true)}
            style={{
              height: 25,
              width: 25,
              backgroundColor: onMenu
                ? BlackAndWhite.primary
                : BlackAndWhite.secondary,
              borderRadius: 4,
              display: "flex",
              justifyContent: "space-evenly",
              alignItems: "center",
              transition: "0.3s",
            }}
          >
            <div
              style={{
                height: 3,
                width: 3,
                borderRadius: 20,
                backgroundColor: onMenu
                  ? BlackAndWhite.secondary
                  : BlackAndWhite.primary,
                transition: "0.3s",
              }}
            />
            <div
              style={{
                height: 3,
                width: 3,
                borderRadius: 20,
                backgroundColor: onMenu
                  ? BlackAndWhite.secondary
                  : BlackAndWhite.primary,
                transition: "0.3s",
              }}
            />
            <div
              style={{
                height: 3,
                width: 3,
                borderRadius: 20,
                backgroundColor: onMenu
                  ? BlackAndWhite.secondary
                  : BlackAndWhite.primary,
                transition: "0.3s",
              }}
            />
          </div>
        </div>
        <div
          // onClick={() => setShrink(shrink ? false : true)}
          style={{
            // marginLeft: shrink ? -5 : 0,
            // backgroundColor: shrink ? "#FFFFFFcc" : BlackAndWhite.secondary,
            height: shrink ? 60 : 60,
            width: shrink ? 60 : 60,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            // borderRadius: shrink ? 200 : 20,
            position: "absolute",
            top: shrink ? 0 : 0,
            // right: shrink ? -5 : 0,
            // WebkitBoxShadow: "0px 0px 10px 1px #00000033",
            transition: "all 0.3s",
            // borderStyle: "solid",
            // borderColor: BlackAndWhite.primary,
            // borderWidth: 5,
            overflow: "hidden",
          }}
        >
          <div
            // onClick={() => setShrink(shrink ? false : true)}
            style={{
              // marginLeft: shrink ? 0 : 5,
              backgroundColor: shrink
                ? BlackAndWhite.primary
                : BlackAndWhite.secondary,
              height: shrink ? 60 : 60,
              minWidth: shrink ? 60 : 60,
              maxWidth: shrink ? 60 : 60,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              // borderRadius: shrink ? 200 : 8,
              // position: "absolute",
              // top: shrink ? 10 : 5,
              // WebkitBoxShadow: "0px 0px 10px 1px #00000033",
              transition: "all 0.3s",
              zIndex: 10000001,
              // borderStyle: "solid",
              // borderColor: BlackAndWhite.primary,
              // borderWidth: 5,
              overflow: "hidden",
            }}
          >
            <img
              alt="load"
              src={require("../../images/rooftopLogo/RoofTopLogo512.png")}
              style={{
                height: shrink ? 50 : 50,
                transition: "all 0.3s",
                zIndex: 10000001,
              }}
            />
          </div>
        </div>
      </div>

      {/* back buttion */}

      {/* screen displayed */}
      <div
        style={{
          height: "100%",
          flex: 1,
          overflowY: "hidden",
          marginTop: 60,
          position: "relative",
          // backgroundColor: "#E7E7E7",
          // backgroundColor: "#FFFFFF99",
          backgroundColor: "#FFFFFF99",
          overflowX: "hidden",
          width: "100%",
          display: "flex",
          flexDirection:
            subSelection === "ALL USERS" || subSelection === "ADD USERS"
              ? "column"
              : "row",
          // marginTop: 50,
        }}
      >
        {tab === "inventory" ? (
          <Inventory
            subSelection={subSelection}
            setSubSelection={setSubSelection}
            auth={admin ? admin.adminUserData : null}
          />
        ) : null}
        {tab === "website" ? <WebsiteDisplayEdit /> : null}
        {tab === "products" ? (
          <MainScreenHolder
            subSelection={subSelection}
            userDisplay={userDisplay}
            setUserdisplay={setUserdisplay}
            setSubSelection={setSubSelection}
            shrink={shrink}
            auth={admin ? admin.adminUserData : null}
          />
        ) : null}
        {tab === "patients" ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              backgroundColor: "#FFFFFF99",
            }}
          >
            <div
              style={{
                height: 55,
                width: "100%",
                display: "flex",
                alignItems: "center",
                backgroundColor: "#FFFFFF",
              }}
            >
              {/* search section */}
              <div style={{ marginLeft: 10, marginRight: 10, marginBottom: 5 }}>
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",

                    // width: 300,

                    borderWidth: 0.5,
                  }}
                >
                  <TextInputFieldSearch
                    placeholder={"Type here to search"}
                    height={30}
                    borderRadius={4}
                    onChange={(e) => setSearch(e.target.value)}
                    value={search}
                  />
                  <div
                    style={{
                      height: 35,
                      width: 70,
                      backgroundColor: BlackAndWhite.primary,
                      borderRadius: 4,
                      display: "flex",
                      color: BlackAndWhite.secondary,
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer",
                      marginLeft: 5,
                    }}
                  >
                    <div
                      onClick={() => {
                        setSearch("");
                        setCustomers(null);
                      }}
                      style={{ fontSize: 12, fontWeight: "bold" }}
                    >
                      CLEAR
                    </div>
                  </div>
                  <div
                    style={{
                      height: 35,
                      width: 70,
                      backgroundColor: BlackAndWhite.primary,
                      borderRadius: 4,
                      display: "flex",
                      color: BlackAndWhite.secondary,
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: search === "" ? "not-allowed" : "pointer",
                      marginLeft: 10,
                    }}
                  >
                    <div
                      onClick={search === "" ? null : () => OnUserSearch()}
                      style={{
                        fontSize: 12,
                        fontWeight: "bold",
                        opacity: search === "" ? 0.5 : 1,
                      }}
                    >
                      SEARCH
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ flex: 1 }}></div>
            </div>
            <HeadersPatients />
            <AdminCustomerTab
              setData={setCsvExport}
              csvExport={csvExport}
              width={width}
              customers={customers}
              setSelectedPatient={setSelectedPatient}
              setPatientProfilePop={setPatientProfilePop}
            />
          </div>
        ) : null}
        {tab === "setupManage" &&
        (subSelection === "ALL USERS" || subSelection === "ADD USERS") ? (
          <Users
            subSelection={subSelection}
            userDisplay={userDisplay}
            setUserdisplay={setUserdisplay}
            setSubSelection={setSubSelection}
          />
        ) : null}
        {tab === "setupManage" && subSelection === "practioners" ? (
          <PractionerTab
            height={height}
            width={width}
            subSelection={subSelection}
            userDisplay={userDisplay}
            setUserdisplay={setUserdisplay}
            setSubSelection={setSubSelection}
          />
        ) : null}
        {tab === "setupManage" &&
        subSelection !== "practioners" &&
        subSelection !== "suppliers" ? (
          <Facilities
            height={height}
            width={width}
            subSelection={subSelection}
            userDisplay={userDisplay}
            setUserdisplay={setUserdisplay}
            setSubSelection={setSubSelection}
          />
        ) : null}
        {subSelection === "suppliers" ? (
          <div style={{ width: width }}>suppliers</div>
        ) : null}
        {tab === "menus" ? (
          <Menus
            subSelection={subSelection}
            userDisplay={userDisplay}
            setUserdisplay={setUserdisplay}
            setSubSelection={setSubSelection}
          />
        ) : null}
        {tab === "dashboard" ? (
          <DashBoard
            height={height}
            patientStatsAvalible={patientStatsAvalible}
            // prescriptionStats={prescriptionStats}
            patientStats={patientStats}
            onRefreshClick={() => setRefresh(refresh ? false : true)}
            loading={loading}
            staffStats={staffStats}
            storeStats={storeStats}
            productStats={productStats}
            shrink={shrink}
          />
        ) : null}
        {tab === "reporting" ? (
          <Reporting
            subSelection={subSelection}
            userDisplay={userDisplay}
            setUserdisplay={setUserdisplay}
            setSubSelection={setSubSelection}
            auth={admin ? admin.adminUserData : null}
          />
        ) : null}
      </div>

      {loading ? (
        <div
          style={{
            width: width,
            // height: "100%",
            zIndex: 20000000,
            position: "absolute",
            top: 0,
          }}
        >
          <LoadingPopUp display={loading} />
        </div>
      ) : null}
      <PatientProfilePopUp
        display={patientProfilePop}
        selectedPatient={selectedPatient}
        onCloseClick={() => {
          setPatientProfilePop(false);
          setSelectedPatient(null);
        }}
        loading={loading}
        setLoading={setLoading}
      />
      <ProfileMenu
        display={onMenu}
        username={
          admin.adminUserData ? admin.adminUserData.userName : "loading"
        }
        idNum={admin.adminUserData ? admin.adminUserData.idDoc : "loading"}
        store={admin.adminUserData ? admin.adminUserData.storeName : "loading"}
        province={
          admin.adminUserData ? admin.adminUserData.province : "loading"
        }
        onCancelClick={() => setOnMenu(false)}
        onLogOutClick={() => {
          admin.logout();
          navigate("/adminPortal");
        }}
      />
    </div>
  );
};

export default AdminEditor;
